module.exports = __webpack_public_path__ + "img/about.8b20c1ee.jpg";